import gql from 'graphql-tag';

import { getSingleProp } from 'src/lib/graphql';
import { executeGqlQuery } from 'src/graphql/client';
import { FRAGMENT_BOOKMARK } from 'src/graphql/user/schema';

const QUERY = gql`
  query UserBookmarks {
    me {
      bookmarks {
        ...Bookmark
      }
    }
  }
  ${FRAGMENT_BOOKMARK}
`;

export const queryUserBookmarks = (token) =>
  executeGqlQuery({
    query: QUERY,
    variables: { token },
  }).then(({ data }) => getSingleProp(data));
